
import { filterBlue, formControlColour, white } from "../BEE123.Constants";
import { MDBox } from "../MDBox";
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Tooltip } from '@mui/material';


interface IDataTableHeadCellProps {
  children: React.ReactNode;
  sorted?: false | "none" | "asce" | "desc";
  align?: "left" | "right" | "center";
  width?: string | number,
  costAlign?: boolean,
  showInfoIcon?: boolean,
  [rest: string]: any;
}

export function DataTableHeadCell({
  children, sorted = "none",
  align = "left",
  costAlign = false,
  showInfoIcon = false,
  ...rest
}: IDataTableHeadCellProps) {


  return (
    <MDBox
      component="th"
      py={1.5}
      px={3}
      sx={({ palette: { light }, borders: { borderWidth } }: any) => ({
        borderBottom: `${borderWidth[1]} solid ${light.main}`,
        paddingLeft: "12px",
        paddingRight: costAlign ? "12px" : "24px"
      })}
    >
      <MDBox
        {...rest}
        position="relative"
        color={"white"}
        sx={({ typography: { size, fontWeightBold } }: any) => ({
          width: '100%',
          fontSize: size.xxs,
          fontWeight: fontWeightBold,
          textTransform: "uppercase",
          cursor: sorted && "pointer",
          userSelect: sorted && "none",
          display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'
        })}
      >
        {
          costAlign ? (
            <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
              {children}
            </div>
          ) :
            <>{children}</>
        }
        {
          showInfoIcon &&
            <Tooltip title={'Hover over text in each cell for more information.'}>
              <InfoOutlinedIcon style={{ color: 'white', marginLeft: '2px' }} />
            </Tooltip>
        }

        {sorted && (
          <MDBox
            position="relative"
            // top={0}
            // right={align !== "right" ? "16px" : 0}
            // left={align === "right" ? "-5px" : "unset"}
            sx={({ typography: { size } }: any) => ({
              fontSize: size.xl,
              right: "-5px",
              width: "24px",
              height: "24px",
              marginTop: "4px"
            })}
          >
            <MDBox
              position="absolute"
              top={-7}
              color={sorted === "asce" ? filterBlue : white}
              opacity={sorted === "desc" ? 0 : 1}
            >
              <ArrowDropUpIcon />
            </MDBox>
            <MDBox
              position="absolute"
              top={0}
              color={sorted === "desc" ? filterBlue : white}
              opacity={sorted === "asce" ? 0 : 1}
            >
              <ArrowDropDownIcon />
            </MDBox>
          </MDBox>
        )}
      </MDBox>
    </MDBox>
  );
}
